import i18n from '@/utils/i18n';
import InfoIcon from '@assets/icons/info.svg';
import React, { useRef } from 'react';
import { createStyles } from '@/contexts/theme-context';
import { shadow } from '@/styles';
import { Tooltip } from '@usepepper/ui/atoms/tooltip';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useHover } from 'react-native-web-hooks';
import { View } from 'react-native';

const INFO_ICON_SIZE = 16;

interface CommissionIndicatorProps {
  displayValue: string;
}

export const CommissionIndicator: React.FC<CommissionIndicatorProps> = ({
  displayValue,
}) => {
  const [styles, theme] = useStyles();
  const hoverRef = useRef<View>(null);
  const isHovered = useHover(hoverRef);

  return (
    <View ref={hoverRef}>
      <Tooltip
        containerStyle={styles.tooltipContainer}
        offset={{ y: 5 }}
        placement="top left"
        tabIndex={-1}
        trigger={
          <View style={styles.iconContainer}>
            <InfoIcon
              height={INFO_ICON_SIZE}
              stroke={
                isHovered
                  ? theme.sk.color.icon.primary
                  : theme.sk.color.icon.tertiary
              }
              width={INFO_ICON_SIZE}
            />
          </View>
        }
      >
        <View style={styles.tooltipContent}>
          <Typography
            color={theme.sk.color.text.secondary}
            variant="paragraph-md"
          >
            {i18n.t(
              'sales_portal.order_entry.checkout_panel.summary.est_commission',
            )}
          </Typography>
          <Typography
            color={theme.sk.color.text.primary}
            variant="paragraph-md"
          >
            {displayValue}
          </Typography>
        </View>
      </Tooltip>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  tooltipContainer: {
    borderColor: theme.sk.color.border.primary,
    borderRadius: theme.sk.radii.radiusMedium,
    borderWidth: 1,
    minWidth: 124,
    padding: theme.sk.spacing.spaceSMedium,
    ...shadow({
      opacity: 0.08,
      radius: 24,
      x: 0,
      y: 12,
    }),
  },
  tooltipContent: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSmall,
    justifyContent: 'space-between',
    minWidth: 124,
  },
}));
